// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--primary-color: #00b5b0;--light-primary: #19f1eb;--secondary-color: #22a8dd;--light-secondary: #b8e4f0;--app-background-color: whitesmoke;--logo-container-background: #151515;--text-color: #333;--gradient: linear-gradient(180deg, #00b5b0 1.04%, #19f1eb 100%);--gradient-border: linear-gradient(90deg, #00b5b0 1.04%, #19f1eb60 100%)}.TaxesCenteredContainer{display:flex;justify-content:center}.TaxesInputContainer{display:flex;align-items:center;gap:10px}.TaxesInputContainer .TaxesInput{flex:1}.TaxesInputContainer .TaxesInput input{text-align:right}.TaxesAddButton{display:flex !important;align-items:baseline;gap:10px}.TaxesCenteredContainerVertical{height:100%;display:flex;align-items:center}.TaxesSwitch .Switch.__active .ant-switch-handle::before{background-color:#00b5b0 !important}", ""]);
// Exports
exports.locals = {
	"primaryColor": "#00b5b0",
	"lightPrimary": "#19f1eb",
	"secondaryColor": "#22a8dd",
	"lightSecondary": "#b8e4f0"
};
module.exports = exports;
